import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-consult-table-empty-state',
  templateUrl: './consult-table-empty-state.component.html',
  styleUrls: ['./consult-table-empty-state.component.scss'],
})
export class ConsultTableEmptyStateComponent {
  @Input() title = 'Nenhum resultado encontrado';
  @Input() description = 'Tente ajustar os filtros ou realizar uma nova pesquisa.';
  @Input() icon = 'search';
}
